export const wsBaseUrl = process.env.NODE_ENV === 'development'
    ? '/WS/'
    : 'https://backupsvps01.jcinformatics.es/WS/';
